import React from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import { LuPackageX, LuBoxes } from "react-icons/lu";
import { InventorySectionProps } from "../types";

const InventorySection: React.FC<InventorySectionProps> = ({
  outOfStockCount,
  lowStockCount,
  inventoryLoading,
  onNavigateOutOfStock,
  onNavigateLowStock,
}) => {
  return (
    <div className="h-100 d-flex flex-column justify-content-between">
      <h4 className="fw-bold mb-3 text-dark fs-5">Inventory</h4>
      <Row className="g-3 flex-grow-1">
        {/* Out of Stock Card */}
        <Col sm={6}>
          <div
            className="rounded-4 p-4 h-100 d-flex flex-column justify-content-between shadow-sm"
            style={{
              backgroundColor: "#FFF5F5",
              border: "1px solid #FED7D7",
            }}
          >
            <div className="d-flex justify-content-between align-items-start mb-2">
              <div
                className="rounded-3 d-flex align-items-center justify-content-center"
                style={{
                  width: 40,
                  height: 40,
                  backgroundColor: "#FEE2E2",
                  color: "#DC2626",
                }}
              >
                <LuPackageX size={20} />
              </div>
              <button
                type="button"
                className="btn btn-link p-0 text-decoration-none fw-semibold small d-flex align-items-center gap-1"
                style={{ color: "#DC2626" }}
                onClick={onNavigateOutOfStock}
              >
                Out of Stock →
              </button>
            </div>
            <div>
              <div
                className="fs-1 fw-bold mb-1"
                style={{ color: "#DC2626" }}
              >
                {inventoryLoading ? (
                  <Spinner animation="border" size="sm" variant="danger" />
                ) : (
                  outOfStockCount
                )}
              </div>
              <div className="text-secondary small fw-medium">
                Check your products
              </div>
            </div>
          </div>
        </Col>

        {/* Products low on stock Card */}
        <Col sm={6}>
          <div
            className="rounded-4 p-4 h-100 d-flex flex-column justify-content-between shadow-sm"
            style={{
              backgroundColor: "#FFFBF2",
              border: "1px solid #FEEBC8",
            }}
          >
            <div className="d-flex justify-content-between align-items-start mb-2">
              <div
                className="rounded-3 d-flex align-items-center justify-content-center"
                style={{
                  width: 40,
                  height: 40,
                  backgroundColor: "#FFEDD5",
                  color: "#EA580C",
                }}
              >
                <LuBoxes size={20} />
              </div>
              <button
                type="button"
                className="btn btn-link p-0 text-decoration-none fw-semibold small d-flex align-items-center gap-1"
                style={{ color: "#EA580C" }}
                onClick={onNavigateLowStock}
              >
                Check stock →
              </button>
            </div>
            <div>
              <div
                className="fs-1 fw-bold mb-1"
                style={{ color: "#EA580C" }}
              >
                {inventoryLoading ? (
                  <Spinner animation="border" size="sm" variant="warning" />
                ) : (
                  lowStockCount
                )}
              </div>
              <div className="text-secondary small fw-medium">
                Products low on stock
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(InventorySection);

